import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import DirectsList from './directsList';

const enhance = compose(
  withTranslation(['common', 'chat']),
);

export default enhance(DirectsList);
